export function formatPromoCodeText(input: string): string {
  return input.trim().replace(/\s+/g, '-');
}
